import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let bugApi = {};

bugApi.getGraphData = (chartTime) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/graph`, {"period":chartTime}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.getStats = () => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/stats`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.getList = (data) => {
  const formData = {};

  if (data) {
    data.forEach((ob) => {
      formData[ob.key]=ob.value;
    });
  }
  formData.limit= 10;
  formData.sort_by="ID";
  formData.sort_order="DESC";
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/list`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.getCategories = () => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/category/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.getTags = () => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/tag/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.addBug = (data) => {
  const formData = {};

  Object.keys(data).forEach((key) => {
    formData[key]=data[key];
  });

  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/create`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.editBug = (data) => {
  const formData = {};

  Object.keys(data).forEach((key) => {
    if(key != "bug_id"){
      formData[key]= data[key];
    }
  });
 
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/${data.bug_id}/update`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.pinBug = (bug_id) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/update`, {"pinned":"on"}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.detachBug = (bug_id) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/update`, {"pinned":"off"}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.deleteBug = (bug_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/delete`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.addComment = (bug_id, commentText) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/comment/add`, {"text":commentText}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.removeComment = (bug_id, commentId) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/comment/${commentId}/delete`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};


bugApi.addAttachment = (bug_id, file) => {
  const formData = new FormData();
  file.forEach((fileInfo) => {
    formData.append("file", fileInfo);
  });

  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/attachment`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

bugApi.fetchBugAttachments = (bug_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/attachment/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};


bugApi.fetchBugComments = (bug_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/bug/${bug_id}/comment/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};
export default bugApi;
